import { axios } from '@/utils/request'

const api = {
  finance: '/finance'
}

export function Recharge (parameter) {//企业支付充值列表
  return axios({
    url: api.finance + '/EnterpriseAccount/list',
    method: 'get',
    params: parameter,
  })
}

export function OfflinePayment (parameter) {//线下支付列表
  return axios({
    url: api.finance + '/pay/OfflinePayment',
    method: 'get',
    params: parameter,
  })
}

export function Payupdate (parameter) {//财务修改支付状态
  return axios({
    url: api.finance + '/pay/update ',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function changeMoney (parameter) {//修改金额
  return axios({
    url: api.finance + '/refund/changeMoney ',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function refundinsert (parameter) {//退款
  return axios({
    url: api.finance + '/refund/insert ',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function detailedList (parameter) {//明细
  return axios({
    url: api.finance + '/detailed/list',
    method: 'get',
    params: parameter,
    // data: parameter,
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}


export const enterpriseBlackListExport = api.enterpriseBlackList + '/export'
